module.exports = __webpack_public_path__ + "media/images/physician-portrait-6a67281c9d610b527b387ca091c334dd.jpg";